{
  "ClientConfigurationModal_AddTitle": "Aggiungi configurazione client",
  "ClientConfigurationModal_ChangeTitle": "Modifica la configurazione del client",
  "ClientConfigurationModal_Footer_Actions_Submit": "Invia",
  "ClientConfigurationModal_Footer_Actions_Cancel": "Cancellare",
  "ClientConfigurationModal_Footer_Actions_Help": "Aiuto",
  "ClientConfigurationModal_Tabs_Details": "Dettagli",
  "ClientConfigurationModal_Tabs_Scope": "Ambito",
  "ClientConfigurationModal_Tabs_Policy": "Politica",
  "ClientConfigurationModal_Tabs_Settings": "Impostazioni",
  "ClientConfigurationModal_Tab_Details_Description": "Descrizione",
  "ClientConfigurationModal_Tab_Details_Description_Required": "La descrizione è obbligatoria",
  "ClientConfigurationModal_Tab_Details_ID": "ID",
  "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Assegnato automaticamente]",
  "ClientConfigurationModal_Tab_Details_Override": "Sostituisci tutte le configurazioni dei client",
  "ClientConfigurationModal_Tab_Scope_CME": "ECM",
  "ClientConfigurationModal_Tab_Scope_Telsys": "Server di telefonia",
  "ClientConfigurationModal_Tab_Scope_Telsys_Required": "È richiesto il server di telefonia",
  "ClientConfigurationModal_Tab_Scope_Partition": "Partizione",
  "ClientConfigurationModal_Tab_Scope_Device": "Dispositivo",
  "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Filtra ricorsivamente",
  "ClientConfigurationModal_Tab_Policy_PolicyItem": "Articolo di politica",
  "ClientConfigurationModal_Tab_Policy_DefaultValue": "Valore predefinito",
  "ClientConfigurationModal_Tab_Policy_ActualValue": "Valore effettivo",
  "ClientConfigurationModal_Policy_core": {
    "showUseConfigurationWindow": "Core - Può mostrare\/utilizzare la finestra di configurazione",
    "permittedToLogin": "Core - Autorizzato ad accedere"
  },
  "ClientConfigurationModal_Policy_configOptions": {
    "useLocalhostAPI": "Configurazione: usa l'API Localhost",
    "canConfigureCustomEvents": "Config - Configura eventi personalizzati"
  },
  "ClientConfigurationModal_Policy_menuOptions": {
    "canShowAddressBook": "Menù - Rubrica"
  },
  "ClientConfigurationModal_Policy_crm": {
    "canAddNewContacts": "È possibile aggiungere nuovi contatti ai CRM (tramite procedura guidata)"
  },
  "ClientConfigurationModal_Tab_Settings_SettingsItem": "Opzione di impostazione",
  "ClientConfigurationModal_Tab_Settings_DefaultValue": "Valore predefinito",
  "ClientConfigurationModal_Tab_Settings_ActualValue": "Valore effettivo",
  "ClientConfigurationModal_Settings_interface": {
    "showCallNotificationPreview": "Interfaccia - Mostra anteprima notifica chiamata",
    "showMissedCallPreview": "Interfaccia - Mostra anteprima chiamate perse",
    "connectedHideDelay": "Interfaccia - Connesso Nascondi Ritardo",
    "previewWindowAlwaysOnTop": "Interfaccia - Finestra di anteprima sempre in primo piano",
    "showContactInEditMode": "Interfaccia - Mostra contatto in modalità di modifica",
    "applicationLoadAtWindowsStartup": "Interfaccia - Caricamento dell'applicazione all'avvio di Windows"
  },
  "ClientConfigurationModal_Settings_hotkey": {
    "makeCall": "Tasto di scelta rapida - Effettua chiamata"
  },
  "ClientConfigurationModal_Settings_dialing": {
    "clipboardDialing": "Composizione - Composizione tramite appunti",
    "focusDialing": "Composizione - Composizione messa a fuoco",
    "screenDialing": "Composizione - Composizione tramite schermo"
  },
  "ClientConfigurationModal_Settings_logPage": {
    "sendAnonymouseStats": "Pagina di registro - Invia statistiche anonime",
    "loggingLevel": "Pagina di registro - Livello di registrazione"
  },
  "ClientConfigurationModal_Settings_version": {
    "checkForUpdates": "Versione - Controlla gli aggiornamenti e scarica"
  },
  "NAME": "ClientConfigurationModalLanguage",
  "ClientConfigurationModal_Error_NotFound": "Configurazione client non trovata o non esistente"
}